<template >
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div>
      <div class="formPosition">
        <v-card style="margin:auto;" width="1240">
          <v-card-title style="background-color:#006699;color:white;"></v-card-title>
          <v-progress-linear style="margin : 0 auto ; height:10px" :indeterminate="isLoading" v-show="isLoading"></v-progress-linear>
          <v-data-table :headers="headers" :items="turmas" :search="searchInDb" sort-by="data_" class="elevation-3">
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-row>
                  <v-col md="8">
                    <v-toolbar-title>Emolumentos Por Turma</v-toolbar-title>
                  </v-col>
                   
                </v-row>
                <v-row>
                  <v-col md="8">
                  </v-col>
                  <v-col md="4">
                    <v-combobox
                        v-model="anoLectivoSelected"
                        :items="Listaranoslectivo"
                        outlined
                          item-value="anolectivo"
                        item-text="anolectivo"
                        @change="selecionarEmolumentos()"
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-toolbar>
              <div style="text-align: center;">
                <v-progress-circular :size="50" color="primary" indeterminate v-if="isLodingPDF"></v-progress-circular>
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-btn fab color="#006699" @click="showDiologo(item)" style="color:white;" small><v-icon small>print</v-icon></v-btn>
            </template>
          </v-data-table>
          
          <template>
            <v-row>
              <v-dialog v-model="dialog" persistent max-width="600px">
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-card>
                    <v-overlay :value="overlay || $store.state.loading_pdf">
                      <v-progress-circular indeterminate size="64"></v-progress-circular>
                    </v-overlay>
                    <v-card-title style="background-color:#006699;color:white;">
                      <span class="text-h5">Seleção o emolumento </span>
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="12">
                            <label>Turma: </label><span style="font-size:15px;font-weight:bold;">{{ (turma !== null) ? turma.turma : '' }}</span>
                          </v-col>
                          <v-col cols="12" md="12">
                            <label>Curso: </label><span style="font-size:15px;font-weight:bold;">{{ (turma !== null) ? turma.curso : '' }}</span>
                          </v-col>
                          <v-col md="12">
                            <v-select v-model="editedItem.emolumento" :rules="ruleRequired" item-value="id" item-text="descricao" :items="emolumentos" label="Selecione o emolumento" return-object></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="black darken-1" text @click="closeDialogo()"> fechar </v-btn>
                      <v-btn color="green darken-1" text :disabled="!valid" @click="Guardar()"> Gerar Lista </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-form>
              </v-dialog>
            </v-row>
          </template>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import Swal from 'sweetalert2';
import axios from '../../../plugins/axios';
import utilitarios from '../../../plugins/utilitarios';
const ls = require('local-storage');
export default {
  data: () => ({
    isLoading: false,
    dados: [],
    emolumentos: [],
    Listaranoslectivo:[],
    turma: null,
    config: null,
    isLodingPDF: false,
    date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    menu: false,
    turmas: [],
    menu2: null,
    anoLectivoSelected: null,
    util: utilitarios,
    headers: [
      {
        text: 'Descrição',
        align: 'left',
        sortable: false,
        value: 'turma'
      },
      { text: 'Curso', value: 'curso' },
      { text: 'Número de estudante', value: 'quantalunos' },
      { text: 'Período', value: 'periodo' },
      { text: 'Data criação', value: 'data_' },
      { text: 'Autor', value: 'autor' },
      { text: 'Ação', value: 'action' }
    ],
    searchInDb: '',
    dialog: false,
    overlay: false,
    editedItem: {
      emolumento: ''
    },
    ruleRequired: [value => !!value || 'campo obrigatorio'],
  }),

  computed: {
    licencaExpirada() {
      return ls.get('licencaExpirada')
    },
    total() {
      let total_ = 0
      this.dados.forEach(element => {
        total_ += element.valorPago
      });
      return total_
    }
  },

  created() {
    this.initializeAnosLectivo()
    this.initializeTurmas(ls.get('anolectivo'))
    this.InitializeEmolumentos()
    
  },

  methods: {
    
    async initializeTurmas( anolectivo ) {
      try {
        this.isLoading = true;
        this.overlay = true;
        this.turmas = await axios.get('/turmasFindAlls/'+anolectivo).then(res => res.data);
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro durante o carregamento das turmas!', 'error')
      } finally {
        this.overlay = false;
        this.isLoading = false;
      }
    },

   async selecionarEmolumentos () {
        this.initializeTurmas(this.anoLectivoSelected.anolectivo)
    },

    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        this.Listaranoslectivo = await axios.get("/listarAnoLectivoAllFinancas").then((res) => res.data);
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os anos lectivos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async InitializeEmolumentos() {
      try {
        this.overlay = true;
        this.emolumentos = await axios.get('getEmolumentosFindAll').then((res) => res.data);
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro durante o carregamento dos emolumentos!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    showDiologo(item) {
      try {
        this.overlay = true;
        this.turma = item;
        this.dialog = true;
      } catch (error) {
        Swal.fire('Informação', 'Ocorreu um erro durante a abertura da tela de seleção de emplumento!', 'error')
      } finally {
        this.overlay = false;
      }
    },

    closeDialogo() {
      this.dialog = false;
    },

    async Guardar() {
      if (this.licencaExpirada) {
        Swal.fire('Informação', 'A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!', 'info');
      } else {
        if (this.$refs.form.validate()) {
          try {
            this.overlay = true;
            this.$store.state.loading_pdf = true;
            
            let estudantes = await this.ListarEstudanteFromTurma(this.turma.pkTurma).then((res) => res.data)
            let queryMesesPagos = await this.ListarEstudanteFromTurmaGetNumeroMatricula({ turma: this.turma.pkTurma, emolumento: this.editedItem.emolumento,anolectivo:this.anoLectivoSelected.anolectivo }).then((res) => res.data)
            let resultPagamentos = await this.RunFinancasQuery(queryMesesPagos).then((res) => res.data)
            ls.set('mesespagos', resultPagamentos);
            ls.set('emolumento', this.editedItem.emolumento);
            ls.set('turma', this.turma);
            ls.set('estudantes', estudantes);
            ls.set('precoPropina', [{ precoComIva: 0 }]);
            ls.set('bolseiros', []);
  
            /*
              Esse trecho de código, imprimirRecibo(), carrega dinamicamente o componente de 
              uma segunda página chamada "recibo-pagamento-escola.vue" e o monta em uma instância 
              temporária do Vue. Isso permite que você exiba e imprima um recibo de pagamento da 
              escola sem interferir na página atual.
            */
  
            import('./emolumentoTurmaPdf.vue').then((module) => {
              const SegundaPagina = module.default;
              const tempInstance = new Vue({
                render: (h) => h(SegundaPagina),
              });
              tempInstance.$mount();
            })
  
            //this.$router.push('relatorio-turma-pdf')
          } catch (error) {
            Swal.fire('Informação', 'Ocorreu um erro ao tentar gerar o pdf', 'error')
          } finally {
            this.overlay = false;
          }
        }
      }
    },

    async ListarEstudanteFromTurma(turma) {
      try {
        return await axios.get('/ListaEstudantes/' + turma).then()
      } catch (error) {
        this.overlay = false;
        Swal.fire('Informação', 'Ocorreu um erro ao tentar carregar os estudantes')
      }
    },

    async ListarEstudanteFromTurmaGetNumeroMatricula(params) {
      try {
        return await axios.post('/ListaEstudantesGetMatriculaByEmolumento', params).then()
      } catch (error) {
        this.overlay = false;
        Swal.fire('Informação', 'Ocorreu um erro ao tentar carregar os estudantes')
      }
    },

    async RunFinancasQuery(query) {
      try {
        return await axios.post('/mesesPagosEstudanteByQuery', query).then()
      } catch (error) {
        this.overlay = false;
        Swal.fire('Informação', 'Ocorreu um erro ao tentar carregar os pagamentos')
      }
    }
  }
}
</script>
 
<style scoped></style>
